module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.7621adca.woff";